<template>
	<app-page>
		<app-heading :title="isNew ? 'New Identity' : identity.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'converge-identities' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="identity.name"
					required
					:errors="errors.name"
				/>
				<input-text
					label="Slug"
					v-model="identity.slug"
					required
					:errors="errors.slug"
				/>
				<input-text
					type="password"
					label="Merchant ID"
					v-model="identity.merchant_id"
					:errors="errors.merchant_id"
					required
				/>
				<input-text
					type="password"
					label="User ID"
					v-model="identity.user_id"
					:errors="errors.user_id"
					required
				/>
				<input-text
					type="password"
					label="Terminal PIN"
					v-model="identity.terminal_pin"
					:errors="errors.terminal_pin"
					required
				/>
				<input-select
					label="Enterprise"
					:items="enterprises"
					v-model="identity.enterprise"
					:errors="errors.enterprise"
				/>
				<input-select
					label="Resort"
					:items="resorts"
					v-model="identity.resort"
					:errors="errors.resort"
				/>
				<input-checkbox
					label="Is default resort identity?"
					v-model="identity.is_default"
					:errors="errors.is_default"
				/>
				<input-text
					label="Studeo ID"
					v-model="identity.studeo_id"
					:errors="errors.studeo_id"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
const PROTECTED_CONTENT = '_PROTECTED'

export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			this.enterprises = await this.$ravello.graphql('enterprises')
				.sort('name')
				.datasource()
				.query()

			this.resorts = await this.$ravello.graphql('resorts')
				.sort('name')
				.datasource()
				.query()

			if (this.id !== 'new') {
				const identity = await this.$ravello.request()
					.v(2)
					.to('converge')
					.to(this.id)
					.get()

				this.identity.name = identity.name
				this.identity.slug = identity.slug || ''
				this.identity.enterprise = identity.enterprise
				this.identity.studeo_id = identity.studeo_id || ''
				if (identity.merchant_id && identity.merchant_id !== '') {
					this.identity.merchant_id = PROTECTED_CONTENT
				}
				if (identity.user_id && identity.user_id !== '') {
					this.identity.user_id = PROTECTED_CONTENT
				}
				if (identity.terminal_pin && identity.terminal_pin !== '') {
					this.identity.terminal_pin = PROTECTED_CONTENT
				}
				this.identity.resort = identity.resort
				this.identity.is_default = identity.is_default || false
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			identity: {
				name: '',
				slug: '',
				merchant_id: '',
				user_id: '',
				terminal_pin: '',
				enterprise: null,
				studeo_id: '',
				resort: null,
				is_default: false,
			},
			enterprises: [],
			resorts: [],
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.identity
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request().v(2).to('converge').create({
						name: this.identity.name,
						slug: this.identity.slug,
						merchant_id: this.identity.merchant_id,
						user_id: this.identity.user_id,
						terminal_pin: this.identity.terminal_pin,
						enterprise: this.identity.enterprise,
						studeo_id: this.identity.studeo_id !== '' ? this.identity.studeo_id : null,
						resort: this.identity.resort,
						is_default: this.identity.is_default || false,
					})
				} else {
					await this.$ravello.request().v(2).to('converge').to(this.id)
						.update({
							name: this.identity.name,
							slug: this.identity.slug,
							enterprise: this.identity.enterprise,
							studeo_id: this.identity.studeo_id !== '' ? this.identity.studeo_id : null,
							...(this.identity.merchant_id && this.identity.merchant_id !== PROTECTED_CONTENT
								? { merchant_id: this.identity.merchant_id } : {}),
							...(this.identity.user_id && this.identity.user_id !== PROTECTED_CONTENT
								? { user_id: this.identity.user_id } : {}),
							...(this.identity.terminal_pin && this.identity.terminal_pin !== PROTECTED_CONTENT
								? { terminal_pin: this.identity.terminal_pin } : {}),
							...(this.identity.resort ? { resort: this.identity.resort } : {}),
							...(typeof this.identity.is_default === 'boolean' ? { is_default: this.identity.is_default } : {}),
						})
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Identity successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'converge-identities' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
